import { StyleSheet } from 'aphrodite'
import { Common } from 'styles'

const styles = StyleSheet.create({
  motionContainer: {
    overflow: 'hidden',
    transition: '500ms ease-out'
  },
  container: {
    minWidth: Common.metaMenuWidth,
    position: 'relative',
    height: '100%',
    backgroundColor: '#fff',
    borderLeft: `1px solid ${Common.borderColor}`,
    order: 75
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/FilterMenu/styles.js